import patentImg from '../assets/patent.png';
import trademarkImg from '../assets/trademark.png';
import copyrightImg from '../assets/copyright.png';
import consultImg from '../assets/consult.png';
import case01Img from '../assets/case01.png';
import case02Img from '../assets/case02.png';

export type ServiceCard = {
  name: string;
  button: string;
  img: string;
  label1: string[];
  label2: string[];
}

export const serviceList: ServiceCard[] = [
  {
    name: '专利服务',
    button: '了解更多',
    img: patentImg,
    label1: ['专利申请', '专利无效诉讼', '专利检索'],
    label2: ['专利驳回复审', '专利布局挖掘', '专利转让'],
  },
  {
    name: '商标服务',
    button: '了解更多',
    img: trademarkImg,
    label1: ['商标注册', '驰名商标认定'],
    label2: ['商标转让', '商标异议评审', '商标国际注册'],
  },
  {
    name: '版权服务',
    button: '了解更多',
    img: copyrightImg,
    label1: ['软件著作权登记'],
    label2: ['文字作品登记', '美术作品登记'],
  },
  {
    name: '咨询服务',
    button: '了解更多',
    img: consultImg,
    label1: ['高新技术企业咨询'],
    label2: ['专精特新中小企业', '专精特新小巨人'],
  }
];

export type CaseCard = {
  name: string;
  img: string;
  info: string;
}

export const caseList: CaseCard[] = [
  {
    name: '一种划线器的划线校准系统',
    img: case01Img,
    info: '本发明涉及划线器数据分析技术领域，尤其涉及一种划线器的划线校准系统。包括信息获取模块，用以根据预设分析周期周期性获取划线器的设备信息和探测移动路径；关联分析模块，用以对划线路径进行分析；路径分析模块，用以对路径类型和样本圆心坐标进行分析；运行分析模块，用以对重合坐标点和差异坐标点、对重合参数进行分析；差异分析模块，用以对差异圆心坐标进行分析；校准分析模块，用以对重合压力参数、差异压力参数和压力波动参数进行分析，还用以对圆心偏离参数进行分析，还用以对校准参数进行分析；划线校准模块，用以根据校准参数对探测移动路径进行校准。本发明实现了对划线器曲面划线的精确校准'
  },
  {
    name: '一种基于自然语言处理的智能问答系统及方法',
    img: case02Img,
    info: '本发明涉及人工智能技术领域，尤其涉及一种基于自然语言处理的智能问答系统及方法，所述系统包括，信息获取模块，用以获取用户输入文本与医疗知识条目；预处理模块，对获取的用户输入文本与医疗知识条目进行预处理；第一向量构建模块，对问题特征向量进行构建，第二向量构建模块，对医疗知识条目的特征向量进行构建；推送模块，向用户进行文本推送；满意度分析模块，获取管理周期内用户对推送结果的评分与评分数量，并对用户的满意度进行分析，根据分析结果对下一管理周期向用户进行文本推送的过程进行优化，分析调整模块，对向用户进行文本推送过程的优化过程进行调整。本发明提高了解答用户问题效率，提高了用户体验感'
  }
];